import React, { Component } from "react";

import { connect } from "react-redux";
import { Row, Col, Card, Button, Switch, Tag, Typography, Modal, Alert, message } from "antd";

import { getAllApps, setAppAsDefault } from "../../reducers/apps/resources";
import {
  getAccessToken,
  removeUserIntegration,
} from "../../reducers/integrations/resources";

import { setUserAppSettingsState } from "../../reducers/integrations/actions";

import CronofyCalendarDialog from "../dialogs/cronofy-calendar-dialog";

import { convertQueryToObj } from "../../utils/object";
import mixpanel from "../../utils/mixpanel";

import _ from "lodash";

import "./index.css";
import config from "../../config";

import exchangeLogo from "../../assets/integrations/exchange.png";
import googleLogo from "../../assets/integrations/google.jpg";
import icloudLogo from "../../assets/integrations/icloud.jpg";
import office365Logo from "../../assets/integrations/office-365.png";
import outlookLogo from "../../assets/integrations/outlook.png";

const { Title, Text, Paragraph } = Typography;

const integrationLogos = {
  exchange: exchangeLogo,
  "exchange.png": exchangeLogo,
  google: googleLogo,
  "google.jpg": googleLogo,
  "google.png": googleLogo,
  icloud: icloudLogo,
  "icloud.jpg": icloudLogo,
  "icloud.png": icloudLogo,
  "office-365": office365Logo,
  "office-365.png": office365Logo,
  office365: office365Logo,
  outlook: outlookLogo,
  "outlook.png": outlookLogo,
};

const appDescriptions = {
  exchange: "Sync your appointments with Microsoft Exchange.",
  google:
    "Sync your appointments with Google Calendar to ensure you never miss an interview.",
  icloud: "Sync your appointments with iCloud Calendar.",
  "office-365": "Sync your appointments with Microsoft Office 365.",
  outlook: "Sync your appointments with Microsoft Outlook Calendar.",
};

class Integrations extends Component {
  componentWillMount = async () => {
    const path = this.props.match.path;

    this.setState({
      showSnackBar: false,
      snackBarMessage: "",
      integrationApps: {},
      authURL: "",
      integApp: null,
      showRemoveDialog: false,
      groups: [],
      calendars: [],
      isIntegrations: !path.includes("/account-setup"),
      showCronofyDialog: false,
    });
  };

  componentDidMount = () => {
    let query = this.props.location.search;

    (async () => {
      await this.loadApps();

      if (!query) {
        return;
      }

      query = convertQueryToObj(query.slice(1));
      const { type } = JSON.parse(decodeURIComponent(query.state));

      try {
        let tokenData = await getAccessToken(
          `code=${query.code}&type=${type}&path=${this.state.isIntegrations}`
        );
        if (type.startsWith("cronofy")) {
          tokenData = tokenData.data;

          this.setState({
            cronofyData: tokenData,
            calendars: tokenData.calendars,
            showCronofyDialog: true,
          });
        }
      } catch {
        this.setState({
          showSnackBar: true,
          snackBarMessage: "There was a problem with the integration.",
        });
      }
    })();
  };

  componentDidUpdate() {
    if (this.state.showSnackBar && this.state.snackBarMessage) {
      message.info(this.state.snackBarMessage);
      this.setState({ showSnackBar: false, snackBarMessage: "" });
    }
  }

  loadApps = async () => {
    let integrationApps = await getAllApps(this.state.isIntegrations);
    integrationApps = integrationApps.data;

    this.setState({
      integrationApps,
      groups: integrationApps.groups,
    });
  };

  handleSetDefault = async (userApp, group) => {
    try {
      mixpanel.track("integration:set default", { data: { userApp, group } });

      await setAppAsDefault({ appDetails: JSON.stringify(userApp), group });

      message.success("App has been set as default");
      await this.loadApps();
    } catch {
      message.error("Failed to set default app");
    }
  };

  handleRemoveIntegration = async () => {
    const { integApp } = this.state;
    if (!integApp) return;

    const { user_id: userId, company_id: companyId, app_id: appId } = integApp;

    mixpanel.track("integrations:remove integration");

    try {
      await removeUserIntegration({ userId, companyId, appId });

      await this.loadApps();
      message.success("Integration removed successfully");
      this.setState({ showRemoveDialog: false, integApp: null });
    } catch {
      message.error("Failed to remove integration");
      this.setState({ showRemoveDialog: false });
    }
  };

  setIntegrationState = (data) => {
    this.setState({ ...data });
  };

  render = () => {
    const { integrationApps, integApp } = this.state;

    const calendarGroups = (this.state.groups || []).filter(
      (group) =>
        group.group === "calendar" ||
        (group.label || "").toLowerCase() === "calendar"
    );

    const groupsUi = calendarGroups.map((group) => {
      const apps = group.apps.filter((app) => app.type !== "calendly");
      if (!apps.length) return null;

      return (
        <Col span={24} key={group.group} style={{ marginBottom: 8 }}>
          <Title
            level={4}
            style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, color: "#455A64" }}
          >
            Calendars
          </Title>
          <Row gutter={[16, 16]}>
            {apps.map((app) => {
              const userApp = _.find(integrationApps.companyApps, { app_id: app.id });
              const isConnected = userApp && !userApp.app.auth_error;
              const hasError = userApp && userApp.app.auth_error;

              let connectionInfo = "";
              if (isConnected) {
                const cd = userApp.app.calendar_details;
                if (cd) {
                  connectionInfo = `${cd.calendar_name || ""} ${
                    cd.profile_name ? `on ${cd.profile_name}` : ""
                  }`.trim();
                }
              }

              const appKey =
                (app.image && app.image.split(".")[0]) || app.name.toLowerCase();
              const defaultDesc =
                appDescriptions[appKey] ||
                appDescriptions[app.name.toLowerCase()] ||
                "Connect and manage this service to enhance your workflow.";
              const description =
                isConnected && connectionInfo ? connectionInfo : defaultDesc;
              const logoSrc =
                integrationLogos[app.image] ||
                integrationLogos[appKey] ||
                `${config.api.host}/api/v1/files/app-logo/${app.image}`;

              return (
                <Col xs={24} sm={12} md={12} lg={6} xl={6} key={app.id}>
                  <Card
                    hoverable
                    style={{
                      height: "100%",
                      borderRadius: "8px",
                      borderColor: "#E6E6E6",
                      display: "flex",
                      flexDirection: "column",
                    }}
                    bodyStyle={{
                      padding: "16px",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ marginBottom: 12 }}>
                      <img
                        src={logoSrc}
                        alt={app.name}
                        style={{
                          width: 32,
                          height: 32,
                          objectFit: "contain",
                          borderRadius: "6px",
                        }}
                      />
                    </div>

                    <Title level={5} style={{ marginBottom: 6, fontSize: 14, fontWeight: 700 }}>
                      {app.name}
                    </Title>

                    <Paragraph
                      type={isConnected && connectionInfo ? undefined : "secondary"}
                      style={{
                        fontSize: 12,
                        color: isConnected && connectionInfo ? "#263238" : "#666",
                        lineHeight: "18px",
                        flex: 1,
                        marginBottom: 16,
                        minHeight: 36,
                        fontWeight: isConnected && connectionInfo ? 500 : 400,
                      }}
                    >
                      {description}
                    </Paragraph>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "auto",
                      }}
                    >
                      {isConnected ? (
                        userApp.is_default ? (
                          <Tag color="success" style={{ marginRight: 0, fontSize: 11, lineHeight: "20px" }}>
                            Default
                          </Tag>
                        ) : (
                          <Button
                            type="text"
                            size="small"
                            style={{ padding: 0, fontSize: 12, color: "#546E7A", fontWeight: 500 }}
                            onClick={() => this.handleSetDefault(userApp, group.group)}
                          >
                            Set As Default
                          </Button>
                        )
                      ) : hasError ? (
                        <Text style={{ color: "#f5222d", fontWeight: 600, fontSize: 12 }}>
                          Connection Error
                        </Text>
                      ) : (
                        <span />
                      )}

                      <Switch
                        size="small"
                        checked={!!isConnected}
                        onChange={(checked) => {
                          if (checked) {
                            window.location.href = app.url;
                          } else if (userApp) {
                            this.setState({ integApp: userApp, showRemoveDialog: true });
                          }
                        }}
                      />
                    </div>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Col>
      );
    });

    let nextBtn;
    if (!this.state.isIntegrations) {
      nextBtn = (
        <Button
          type="primary"
          onClick={() => {
            this.props.history.replace("/account-setup/send-first-sms");
          }}
        >
          Next
        </Button>
      );
    }

    return (
      <div style={{ height: "100%", backgroundColor: "#FBFBFB", overflowY: "auto", paddingBottom: "150px" }}>
        <div style={{ height: "80px", backgroundColor: "#F5F5F5" }}>
          <div style={{ height: "100%", width: "90%", padding: "20px", margin: "0 auto" }}>
            <h2 style={{ margin: 0 }}>Integrations</h2>
          </div>
        </div>
        <div className="integration-setting-content" style={{ width: "90%", margin: "0 auto" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              margin: "24px 0 16px",
            }}
          >
            <div>
              <h3 style={{ fontSize: 18, fontWeight: 600, margin: "0 0 4px 0", color: "#263238" }}>
                Integration Settings
              </h3>
              <Text type="secondary">
                Connect a calendar so candidates can self-schedule interviews
              </Text>
            </div>
            {nextBtn}
          </div>

          <Row gutter={[16, 16]} className="tour-integrations-select">
            {groupsUi}
          </Row>

          <CronofyCalendarDialog
            openDialog={this.state.showCronofyDialog}
            calendars={this.state.calendars}
            cronofyData={this.state.cronofyData}
            setIntegrationState={this.setIntegrationState}
            loadApps={this.loadApps}
          />

          <Modal
            title="Remove Integration"
            open={this.state.showRemoveDialog}
            onOk={this.handleRemoveIntegration}
            onCancel={() => this.setState({ showRemoveDialog: false, integApp: null })}
            okText="Yes"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Paragraph>
              Are you sure you want to remove {integApp ? integApp.app.name : ""} integration?
            </Paragraph>
            {integApp && integApp.app.type === "merge" && (
              <Alert
                message="Caution"
                description="If you want to reintegrate, you will have to go through the initial sync sequence again."
                type="warning"
                showIcon
              />
            )}
          </Modal>
        </div>
      </div>
    );
  };
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUserAppSettingsState(data) {
      dispatch(setUserAppSettingsState(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Integrations);
